/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Linkable } from '@/components/blocks/Linkable';
import { headerLinkSX } from '@/components/content/Header/styles/link';
import { useLocalization } from '@/data/Localization';
import { FC, useEffect, useState } from 'react';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { combineSX } from '@/utils/combineSX';
import { flexCentered } from '@/styles/common';
import { Badge } from '@mui/material';
import { headerWishlistBadgeSX } from '../styles/badge';
import { useWishLists } from '@/data/Content/WishLists';
import { useNotifications } from '@/data/Content/Notifications';

export const WishlistIcon: FC = () => {

	const RouteLocal = useLocalization('Routes');
	const WishListTitle = useLocalization("Header").Actions.WishList.t();
	
	const { count: itemCount, mutateWishLists , } = useWishLists();
	
	const [count, setCount] = useState<number>(0);  
	const { message } = useNotifications();
	
	useEffect(() => {
		setCount(() => itemCount || 0);
	}, [itemCount]);
	
	useEffect(() => {
		if (message.isAddToWishList) {
			mutateWishLists();
		}
	}, [message.isAddToWishList,mutateWishLists]);

	return (
		<Badge badgeContent={count} color="secondary" sx={headerWishlistBadgeSX}>
			<Linkable
				href={`/${RouteLocal.WishLists.route.t()}`}
				id={RouteLocal.WishLists.route.t()}
				data-testid={RouteLocal.WishLists.route.t()}
				sx={combineSX([headerLinkSX, flexCentered])}
				aria-label={WishListTitle}
			>

				<FavoriteBorderIcon sx={{ fontSize: 24 }} />
			</Linkable>
		</Badge>
	);
};
